import api from "./api";

const tvShowService = {

  async getAllTvShow(params = {}) {
    try {
      const {
        perPage = "10",
        currentPage = "1",
        searchText = "",
        genre_list = [],
        rating_list = [],
      } = params;

      const queryParams = new URLSearchParams();
      queryParams.append("perPage", perPage);
      queryParams.append("currentPage", currentPage);
      if (searchText) queryParams.append("search", searchText);
      if (genre_list.length > 0)
        queryParams.append("genre_list", genre_list.join(","));
      if (rating_list.length > 0)
        queryParams.append("rating_list", rating_list.join(","));

      const queryString = queryParams.toString();
      const url = `/admin/tv_show${queryString ? `?${queryString}` : ""}`;

      const response = await api.get(url);
      return response;
    } catch (error) {
      console.error("Error fetching TV shows:", error);
      throw error;
    }
  },

  async getSingleTvShow(tvShowId) {
    try {
      const response = await api.get(`/admin/tv_show/${tvShowId}`);
      return response;
    } catch (error) {
      console.error("Error fetching TV show:", error);
      throw error;
    }
  },

  async addTvShow(payload) {
    try {
      const response = await api.post("/admin/tv_show/", payload);
      return response;
    } catch (error) {
      console.error("Error adding TV show:", error);
      throw error;
    }
  },

  async editTvShow(tvShowId, payload) {
    try {
      const response = await api.put(`/admin/tv_show/${tvShowId}`, payload);
      return response;
    } catch (error) {
      console.error("Error editing TV show:", error);
      throw error;
    }
  },

  // TV Show Episode methods
  async getAllTvShowEpisode(params = {}) {
    try {
      const { tv_show_id, season_no, perPage, currentPage, searchText } =
        params;

      // Only what was actually passed goes into the query. Interpolating every
      // key put the literal "undefined" in the URL for the ones that were not,
      // and the API parses season_no with parseInt — so a refresh that omitted
      // it asked for season NaN and came back as an error instead of a list.
      const queryParams = new URLSearchParams();
      const append = (key, value) => {
        if (value !== undefined && value !== null && value !== "") {
          queryParams.append(key, value);
        }
      };
      append("tv_show_id", tv_show_id);
      append("season_no", season_no);
      append("perPage", perPage);
      append("currentPage", currentPage);
      append("search", searchText);

      const response = await api.get(
        `/admin/tv_show_episode?${queryParams.toString()}`
      );
      return response;
    } catch (error) {
      console.error("Error fetching TV show episodes:", error);
      throw error;
    }
  },

  async getSingleTvShowEpisode(episodeId) {
    try {
      const response = await api.get(`/admin/tv_show_episode/${episodeId}`);
      return response;
    } catch (error) {
      console.error("Error fetching TV show episode:", error);
      throw error;
    }
  },

  async addTvShowEpisode(payload) {
    try {
      const response = await api.post("/admin/tv_show_episode", payload);
      return response;
    } catch (error) {
      console.error("Error adding TV show episode:", error);
      throw error;
    }
  },

  async editTvShowEpisode(episodeId, payload) {
    try {
      const response = await api.put(
        `/admin/tv_show_episode/${episodeId}`,
        payload
      );
      return response;
    } catch (error) {
      console.error("Error editing TV show episode:", error);
      throw error;
    }
  },

  // Complete TV Show with Seasons and Episodes
  async addCompleteTvShow(payload) {
    try {
      const response = await api.post("/admin/tv_show/complete", payload);
      return response;
    } catch (error) {
      console.error("Error adding complete TV show:", error);
      throw error;
    }
  },

  // Upload URL
  async getUploadUrl() {
    try {
      const response = await api.get("/admin/get-upload-url");
      return response;
    } catch (error) {
      console.error("Error getting upload URL:", error);
      throw error;
    }
  },

  getSrtUploadUrl: () => {
    return api.get("/admin/subtitles/upload");
  },
};

export default tvShowService;
